class EditionAnyday extends HTMLElement {
	constructor() {
		super();

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.getContentFromSection = this.getContentFromSection.bind(this);
		this.handleSelection = this.handleSelection.bind(this);
	}


	connectedCallback() {
		const anydayBtn = this
		anydayBtn.addEventListener('click', this.openModal);
	}

	reInitEvents() {
		const closeBtn = document.querySelector('.anyday-dialog-close');
		closeBtn.addEventListener('click', this.closeModal);

		const options = document.querySelectorAll('.anyday-payment-option');
		options.forEach(option => option.addEventListener('click', () => {
			this.handleSelection(options, option);
		})
		);
	}

	openModal() {
		console.log('open modal')
		this.getContentFromSection();

		const anydayOverlay = document.querySelector('.anyday-overlay-mask');
		const anydayModal = document.querySelector('.anyday-dialog-box');

		anydayOverlay.style.zIndex = '9999';
		anydayOverlay.classList.add('anyday-overlay-active');
		anydayModal.classList.add('anyday-show');
	}

	closeModal() {
		const anydayOverlay = document.querySelector('.anyday-overlay-mask');
		const anydayModal = document.querySelector('.anyday-dialog-box');

		anydayOverlay.style.zIndex = '-1';
		anydayOverlay.classList.remove('anyday-overlay-active');
		anydayModal.classList.remove('anyday-show');
	}


	handleSelection(options, option) {
		console.log(options, option)
		options.forEach(option => option.classList.remove('anyday-payment-option-selected'));
		option.classList.add('anyday-payment-option-selected');
	}

	async getContentFromSection() {
		let url = window.location.href;
		try {
			const response = await window.fetch(`${url}?section_id=editionanyday`);
			if (response.ok) {
				const responseText = await response.text();
				const fresh = document.createElement('div');
				fresh.innerHTML = responseText;

				console.log(response)
				const selectorElement = document.querySelector('[data-anyday-content]');
				if (selectorElement.innerHTML === fresh.querySelector('[data-anyday-content]').innerHTML) return;
				selectorElement.innerHTML = fresh.querySelector('[data-anyday-content]').innerHTML;
			}
		}

		catch (error) {
			console.log(error);
		}

		finally {
			this.reInitEvents();
		}
	}
}

customElements.define('edition-anyday', EditionAnyday);